import request from "@/api/config.js";

export function AdminNotificationTGCreate(data) {
  return request({
    url: `admin_notifications_tg/tg/new`,
    method: "post",
    data,
  });
}

export function AdminNotificationTGList(data) {
  return request({
    url: `admin_notifications_tg/tg/list`,
    method: "post",
    data,
  });
}

export function AdminNotificationTGDelete(data) {
  return request({
    url: `admin_notifications_tg/tg/delete`,
    method: "post",
    data,
  });
}